import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { sendPasswordResetEmail } from '../../store/actions/authActions';
import Button from '../../components/Button';
import { Link } from 'react-router-dom';
import AnimationLayout from '../../components/AnimationLayout';
import { motion } from 'framer-motion';

const RecoverPassword = () => {
    const [state, setState] = useState({
        email: '',
        errors: {
            email: ''
        }
    })

    const handleSubmit = (event) => {
        event.preventDefault();
        if (state.email === '') {
            setState({ ...state, errors: { email: 'Por favor insira um email' } })
        } else if (state.errors.email === '') {
            console.log('olá')
            dispatch(sendPasswordResetEmail(state.email))
        }
    }

    const handleChange = (event) => {
        event.preventDefault()
        const validEmailRegex = RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
        let errors = state.errors
        if (validEmailRegex.test(event.target.value)) {
            errors.email = ''
        } else {
            errors.email = 'O email que inseriu não é válido.'
        }
        setState({ ...state, [event.target.name]: event.target.value })
    }

    const spanError = (error) => {
        let { errors } = state
        return (
            <motion.span
                initial={{ opacity: 0, y: -25, display: 'none' }}
                animate={errors?.[error] ?
                    { opacity: 1, y: 0, display: 'block' } :
                    { opacity: 0, y: -25, transitionEnd: { display: 'none' } }
                }
                transition={{ duration: 0.5, ease: 'easeInOut' }}
                className='bg-red-500 text-sm font-medium rounded text-white shadow p-2'
            >
                {(errors?.[error] && errors?.[error] !== '') && errors?.[error]}
            </motion.span>
        )
    }

    const dispatch = useDispatch()

    return (
        <AnimationLayout>
            <div className='flex flex-col justify-center items-center w-4/5 mx-auto'>
                <div className='white-container'>
                    <h2 className='pb-2'>Esqueceu-se da sua senha?</h2>
                    <p className='pb-4'>Não se preocupe, preencha o formulário abaixo com o seu email e irá receber um email que lhe permitirá a criação de uma nova senha.</p>
                    <form noValidate method='POST'>
                        <label className="block text-gray-700 font-bold mb-4">
                            <span>Email</span>
                            <input
                                required
                                aria-required
                                type='email'
                                name='email'
                                placeholder="Escreva aqui o seu email"
                                onChange={handleChange}
                                className='text-sm shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 my-3'
                            />
                            {spanError('email')}
                        </label>
                        <div className='flex justify-end'>
                            <Link to='/'>
                                <Button>Voltar</Button>
                            </Link>
                            <Button className='mr-0' onClick={(event) => handleSubmit(event)} >Confirmar</Button>
                        </div>
                    </form>
                </div>
            </div>
        </AnimationLayout>
    )
}

export default RecoverPassword;